import { createSelector } from 'reselect'
import { selectBase } from 'selectors/bootstrap/selectBase'
import { STATES as STORE_STATES } from 'reducers/bootstrap'

export const selectIsAgentsBootstrapped = createSelector(
  selectBase,
  bootstrap => bootstrap.agents === STORE_STATES.LOADED
)
